module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-laughing-5e4e631e.svg";